<template>
  <div class="row">
    <div class="flex md7">
      <va-card :title="detailsCardTitle">
        <div class="row">
          <div class="flex md10">
            <va-input v-model="item.name" label="Name" />
          </div>
        </div>
        <div class="row">
          <div class="flex md8 py-0">
            <va-input v-model="item.address" label="Address" />
          </div>
        </div>
        <div class="row">
          <div class="flex md8 py-0">
            <va-input v-model="item.address2" label="" />
          </div>
        </div>
        <div class="row">
          <div class="flex md6 py-0">
            <va-input v-model="item.city" label="City" />
          </div>
          <div class="flex md2 py-0">
            <va-input v-model="item.state" label="State" />
          </div>
          <div class="flex md4 py-0">
            <va-input v-model="item.postalcode" label="Postal Code" />
          </div>
        </div>
        <div class="row">
          <div class="flex md6 py-0">
            <va-input v-model="item.country" label="Country" />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select label="Timezone" v-model="item.timezone" :options="tzOptions" maxHeight="25vh" />
          </div>
        </div>
        <div class="row">
          <div class="flex md6 sm6 xs12">
            <va-input v-model="item.longitude" label="Long." />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input v-model="item.latitude" label="Lat." />
          </div>
        </div>
        <div class="row">
          <div class="flex md4 sm6 xs12">
            <va-input v-model="item.paid_thru_date" label="Paid-thru Date (YYYY/MM/DD)" />
            <!-- <va-date-picker label="Paid-thru Date" v-model="item.paid_thru_date" /> DatePicker isn't working for some reason -->
          </div>
        </div>

        <div class="row">
          <va-button @click="mainSave" :disabled="!hasDataChanged">{{ detailsSaveButtonText }}</va-button>
          <va-button @click="mainCancel" :disabled="!(hasDataChanged || addingNew)">Cancel</va-button>

          <span v-if="showSaving" class="notif">Saving...</span>
          <span v-if="showSaved" class="notif">Saved</span>
          <span v-if="showChangesWarning" class="notif" style="color: red">Save or Cancel changes before selecting another site</span>
        </div>
      </va-card>
    </div>

    <div class="flex md5">
      <div>
        <div class="flex md12">
          <va-card title="Gateways" v-if="showGateways">
            <template slot="actions">
              <va-button :disabled="!canAddGw" @click="addGwToSite"> Add </va-button>
            </template>

            <va-data-table :fields="fields" :data="siteGwsList" no-pagination no-data-label="" hoverable v-if="!siteGwsListLoading" style="height: 20vh">
              <template slot="trash" slot-scope="props">
                <va-button flat @click="removeGw(props.rowData)">
                  <font-awesome-icon icon="trash-alt" class="trash" title="Remove from site" />
                </va-button>
              </template>
            </va-data-table>
          </va-card>
        </div>
        <div class="flex md12">
          <va-card title="Accounts" v-if="showGateways">
            <!-- <template slot="actions">
              <va-button :disabled="!canAddGw" @click="addGwToSite"> Add </va-button>
            </template> -->

            <va-data-table :fields="fieldsAccts" :data="SiteAcctsList" no-pagination no-data-label="" hoverable v-if="!siteAcctsListLoading" style="height: 20vh">
            </va-data-table>
          </va-card>
        </div>
        <div class="flex md12">
          <va-card title="Users" v-if="showGateways">
            <va-data-table :fields="fieldsUsers" :data="SiteUsersList" no-pagination no-data-label="" hoverable v-if="!siteUsersListLoading" style="height: 20vh">
            </va-data-table>
          </va-card>
        </div>
      </div>
    </div>

    <va-modal v-model="showAddGwDialog" :noOutsideDismiss="true" :hideDefaultActions="true" title="Add GW to Site">
      <form>
        <va-select label="Gateway" v-model="dialogGwVal" :options="allGwsList" :clearValue="allGwsList[0]" :noClear="true" :clearOnMount="false" searchable style="width: 30vw" />
      </form>
      <!-- <div class="row">
        <va-checkbox label="Show all" v-model="dialogShowAllGws" />
      </div> -->

      <template slot="actions">
        <va-button @click="dialogAddGw">Add</va-button>
        <va-button @click="dialogCancelGw">Cancel</va-button>
      </template>
      <span v-if="showSaving">Adding...</span>
      <span style="color: red">{{ errorAdding }}</span>
    </va-modal>

    <va-modal v-model="showConfirmModal" :noOutsideDismiss="true" :hideDefaultActions="true" title="Remove Gateway">
      <p>Remove gateway from this site?</p>

      <template slot="actions">
        <va-button @click="confirmRemove">Remove</va-button>
        <va-button @click="cancelRemove">Cancel</va-button>
      </template>
    </va-modal>
  </div>
</template>

<script>
import hiqapi from '@/hiqapi/hiqapi'

export default {
  data() {
    return {
      siteGwsList: [],
      siteGwsListLoading: false,

      SiteAcctsList: [],
      siteAcctsListLoading: false,

      SiteUsersList: [],
      siteUsersListLoading: false,

      showAddGwDialog: false,
      allGwsList: [],
      allSitesListLoading: false,
      dialogGwVal: null,
      dialogShowAllGws: false,
      errorAdding: '',

      showConfirmModal: false,
      gwToRemove: null,

      item: {},
      itemOrig: null,
      showChangesWarning: false,
      showSaving: false,
      showSaved: false,

      tzOptions: [
        'America/Chicago',
        'America/Denver',
        'America/Los_Angeles',
        'America/New_York',
        'America/Phoenix',
        'Pacific/Honolulu',
        '---',
        'Africa/Cairo',
        'Africa/Casablanca',
        'Africa/Harare',
        'Africa/Lagos',
        'Africa/Nairobi',
        'Africa/Windhoek',
        'America/Adak',
        'America/Anchorage',
        'America/Argentina/Buenos_Aires',
        'America/Bogota',
        'America/Caracas',
        'America/Chihuahua',
        'America/Godthab',
        'America/Managua',
        'America/Manaus',
        'America/Mexico_City',
        'America/Montevideo',
        'America/Noronha',
        'America/Santiago',
        'America/Sao_Paulo',
        'America/Tijuana',
        'Asia/Almaty',
        'Asia/Amman',
        'Asia/Baku',
        'Asia/Bangkok',
        'Asia/Beirut',
        'Asia/Calcutta',
        'Asia/Dhaka',
        'Asia/Hong_Kong',
        'Asia/Irkutsk',
        'Asia/Jerusalem',
        'Asia/Kabul',
        'Asia/Karachi',
        'Asia/Katmandu',
        'Asia/Krasnoyarsk',
        'Asia/Kuala_Lumpur',
        'Asia/Kuwait',
        'Asia/Magadan',
        'Asia/Muscat',
        'Asia/Rangoon',
        'Asia/Seoul',
        'Asia/Taipei',
        'Asia/Tbilisi',
        'Asia/Tehran',
        'Asia/Tokyo',
        'Asia/Vladivostok',
        'Asia/Yakutsk',
        'Asia/Yekaterinburg',
        'Asia/Yerevan',
        'Atlantic/Azores',
        'Atlantic/Cape_Verde',
        'Australia/Adelaide',
        'Australia/Brisbane',
        'Australia/Canberra',
        'Australia/Darwin',
        'Australia/Hobart',
        'Australia/Perth',
        'Canada/Atlantic',
        'Canada/Newfoundland',
        'Canada/Saskatchewan',
        'Europe/Amsterdam',
        'Europe/Athens',
        'Europe/Belgrade',
        'Europe/Brussels',
        'Europe/Helsinki',
        'Europe/Minsk',
        'Europe/Moscow',
        'Europe/Sarajevo',
        'Pacific/Auckland',
        'Pacific/Fiji',
        'Pacific/Guam',
        'Pacific/Midway',
        'Pacific/Tongatapu',
      ],
    }
  },
  computed: {
    fields() {
      return [
        { name: 'name', sortField: 'name', title: 'Name' },
        { name: '__slot:trash', title: '' },
      ]
    },
    fieldsAccts() {
      return [
        { name: 'name', sortField: 'name', title: 'Name' },
      ]
    },
    fieldsUsers() {
      return [
        { name: 'account_name', sortField: 'account_name', title: 'Account' },
        { name: 'name', sortField: 'name', title: 'Name' },
        { name: 'email', sortField: 'email', title: 'Email' },
      ]
    },
    hasDataChanged() {
      if (!this.itemOrig) {
        return false
      }
      for (let key of Object.keys(this.itemOrig)) {
        if (this.itemOrig[key] !== this.item[key]) {
          return true
        }
      }
      return false
    },
    addingNew() {
      return this.item && this.item.id === 0
    },
    detailsCardTitle() {
      if (this.addingNew) {
        return 'Add New Site'
      } else {
        return 'Details'
      }
    },
    detailsSaveButtonText() {
      if (this.addingNew) {
        return 'Add'
      } else {
        return 'Save'
      }
    },
    canAddGw() {
      return this.siteGwsList.length === 0
    },
    showGateways() {
      return this.item && this.item.id > 0
    },
  },

  methods: {
    async mainSave() {
      console.log('SAVE', this.item)
      this.showChangesWarning = false
      this.showSaving = true

      let resp = null
      if (this.addingNew) {
        resp = await hiqapi.postPutWait('post', '/sites', this.item)
      } else {
        resp = await hiqapi.postPutWait('put', '/sites/' + this.item.id, this.item)
      }
      this.showSaving = false

      console.log('BACK resp=', resp)

      if (resp.status !== 200 && resp.status !== 201) {
        console.log(resp)
        this.showToast(`Error: ${resp.data.message}`, {
          position: 'top-center',
          duration: 6000,
        })

        return
      }
      this.showSaved = true
      setTimeout(() => (this.showSaved = false), 2000)

      this.itemOrig = { ...this.item }
      this.reloadSiteList()
    },

    mainCancel() {
      console.log('NO SAVE')
      this.showChangesWarning = false

      if (this.addingNew) {
        this.itemOrig = {}
      }
      this.item = { ...this.itemOrig }
    },

    reloadSiteList() {
      this.$root.$emit('reload_site_list', null, null)
    },

    // Remove gw from site

    removeGw(gw) {
      console.log('Remvoe gw: ', gw)
      this.gwToRemove = gw
      this.showConfirmModal = true
    },

    async confirmRemove() {
      console.log('REMOVE ', this.gwToRemove)
      this.errorSaving = ''
      this.showSaving = true

      let data = {
        site_id: null,
      }

      let resp = await hiqapi.postPutWait('put', `/gateways/${this.gwToRemove.serial}`, data)

      this.showSaving = false

      if (resp.status >= 400) {
        this.errorAdding = resp.data.message
      } else {
        this.showToast('Gateway removed', {
          position: 'top-right',
        })

        this.showConfirmModal = false
      }

      this.siteGwsListLoading = true
      hiqapi.getcb(`/gateways?site_id=${this.item.id}`, this.setDataSiteGws)
    },

    cancelRemove() {
      this.showConfirmModal = false
    },

    // Add gw to site

    addGwToSite() {
      if (this.showAddGwDialog) {
        return
      }
      hiqapi.getcb('/gateways?nosite=true', this.setDataAllGws)

      console.log('ADD')
      this.showSaving = false
      this.errorAdding = ''
      this.showAddGwDialog = true
      this.dialogShowAllGws = false
    },

    async dialogAddGw() {
      console.log('SAVE ', this.item.id, this.dialogGwVal.id)
      this.errorSaving = ''
      this.showSaving = true

      let data = {
        site_id: this.item.id,
      }

      let resp = await hiqapi.postPutWait('put', `/gateways/${this.dialogGwVal.id}`, data)

      this.showSaving = false

      if (resp.status >= 400) {
        this.errorAdding = resp.data.message
      } else {
        this.showToast('Site added', {
          position: 'top-right',
        })

        this.showAddGwDialog = false
      }

      this.siteGwsListLoading = true
      hiqapi.getcb(`/gateways?site_id=${this.item.id}`, this.setDataSiteGws)
    },

    dialogCancelGw() {
      console.log('CANCEL')
      this.showAddGwDialog = false
    },

    setDataSiteGws(newval) {
      console.log('setDataSiteGws:', newval)
      this.siteGwsListLoading = false
      this.siteGwsList = newval.items
      // Vuetable uses "item_id" to track which row is selected
      this.siteGwsList.forEach((item) => {
        item['item_id'] = item['serial'].toString()
        for (let f in item) {
          if (!item[f]) {
            item[f] = '' // change nulls to empty strings
          }
        }
        item['name'] = `${item['serial']} ${item['name']}`
      })
      this.siteGwsList.sort((a, b) => {
        return a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      })

      console.log('Site details gwlist SET DATA: ', newval)
    },

    setDataAcctsList(newval) {
      console.log('setDataAcctsList:', newval)
      this.siteAcctsListLoading = false
      this.SiteAcctsList = newval.items
      // Vuetable uses "item_id" to track which row is selected
      this.SiteAcctsList.forEach((item) => {
        item['item_id'] = item['id'].toString()
        for (let f in item) {
          if (!item[f]) {
            item[f] = '' // change nulls to empty strings
          }
        }
      })
      this.SiteAcctsList.sort((a, b) => {
        return a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      })

      console.log('Site details accts SET DATA: ', newval)
    },

    setDataUsersList(newval) {
      console.log('setDataUsersList:', newval)
      this.siteUsersListLoading = false
      this.SiteUsersList = newval.items
      // Vuetable uses "item_id" to track which row is selected
      this.SiteUsersList.forEach((item) => {
        item['item_id'] = item['id'].toString()
        for (let f in item) {
          if (!item[f]) {
            item[f] = '' // change nulls to empty strings
          }
        }
        item['name'] = item['first_name'] + ' ' + item['last_name']
        item['_sort_'] = item['account_name'] + item['name'] + item['email']
      })
      this.SiteUsersList.sort((a, b) => {
        return a._sort_ > b._sort_ ? 1 : b._sort_ > a._sort_ ? -1 : 0
      })

      console.log('Site details users SET DATA: ', newval)
    },
    setDataAllGws(newval) {
      this.allGwsList = []
      if (!newval) {
        return
      }
      newval.items.forEach((item) => {
        if (!item.name) {
          item.name = ''
        }
        this.allGwsList.push({ id: '' + item.serial, text: `${item.serial} ${item.name}` })
      })

      this.allGwsList.sort((a, b) => (a.serial > b.serial ? 1 : b.serial > a.serial ? -1 : 0))
      console.log('Add site list (all sites): ', newval, this.allGwsList)
    },
  },

  mounted() {
    this.$root.$on('site_selected', (arg1, arg2) => {
      if (this.hasDataChanged) {
        this.showChangesWarning = true
        return
      }
      this.showChangesWarning = false

      this.itemOrig = arg1
      this.item = { ...arg1 }
      console.log('UD Message received: ', arg1, arg2)

      console.log('itemOrig ===> ', this.itemOrig)

      if (!this.addingNew) {
        // this.item.id==0 for "add new"
        this.siteGwsListLoading = true
        hiqapi.getcb(`/gateways?site_id=${this.item.id}`, this.setDataSiteGws)
        hiqapi.getcb(`/accounts?site_id=${this.item.id}`, this.setDataAcctsList)
        hiqapi.getcb(`/users?site_id=${this.item.id}`, this.setDataUsersList)
      }
    })
  },
}
</script>

<style scoped>
.notif {
  align-self: center;
  padding-left: 40px;
}
.trash {
  color: #ff7575;
}
.trash:hover {
  color: #ff3b3b;
}
</style>
